import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WarehouseState } from "src/types/warehouse.types";

const initialState: WarehouseState = {
  createWarehouse: {
    loading: false,
    data: null,
    error: null,
  },
  editWarehouse: {
    loading: false,
    data: null,
    error: null,
  },
  warehouseList: {
    loading: false,
    data: null,
    error: null,
  },
  deleteWarehouse: {
    loading: false,
    data: null,
    error: null,
  },
};

const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {
    // create warehouse actions
    createWarehouseRequest: (state, action: PayloadAction<any>) => {
      state.createWarehouse.loading = true;
      state.createWarehouse.data = null;
      state.createWarehouse.error = null;
    },
    createWarehouseSuccess: (state, action: PayloadAction<any>) => {
      state.createWarehouse.loading = false;
      state.createWarehouse.data = action.payload;
      state.createWarehouse.error = null;
    },
    createWarehouseError: (state, action: PayloadAction<string>) => {
      state.createWarehouse.loading = false;
      state.createWarehouse.data = null;
      state.createWarehouse.error = action.payload;
    },
    resetCreateWarehouse: (state) => {
      state.createWarehouse = { loading: false, data: null, error: null };
    },

    // edit warehouse actions
    editWarehouseRequest: (state, action: PayloadAction<any>) => {
      state.editWarehouse.loading = true;
      state.editWarehouse.data = null;
      state.editWarehouse.error = null;
    },
    editWarehouseSuccess: (state, action: PayloadAction<any>) => {
      state.editWarehouse.loading = false;
      state.editWarehouse.data = action.payload;
      state.editWarehouse.error = null;
    },
    editWarehouseError: (state, action: PayloadAction<string>) => {
      state.editWarehouse.loading = false;
      state.editWarehouse.data = null;
      state.editWarehouse.error = action.payload;
    },
    resetEditWarehouse: (state) => {
      state.editWarehouse = { loading: false, data: null, error: null };
    },

    // get warehouse list
    getWarehouseListRequest: (
      state,
      action: PayloadAction<{
        page?: number;
        limit: number;
        search?: string;
        status?: "active" | "inactive";
      }>
    ) => {
      state.warehouseList.loading = true;
      state.warehouseList.data = null;
      state.warehouseList.error = null;
    },
    getWarehouseListSuccess: (state, action: PayloadAction<any>) => {
      state.warehouseList.loading = false;
      state.warehouseList.data = action.payload;
      state.warehouseList.error = null;
    },
    getWarehouseListError: (state, action: PayloadAction<string>) => {
      state.warehouseList.loading = false;
      state.warehouseList.data = null;
      state.warehouseList.error = action.payload;
    },
    resetWarehouseList: (state) => {
      state.warehouseList = { loading: false, data: null, error: null };
    },

    // delete warehouse actions
    deleteWarehouseRequest: (state, action: PayloadAction<string>) => {
      state.deleteWarehouse.loading = true;
      state.deleteWarehouse.data = null;
      state.deleteWarehouse.error = null;
    },
    deleteWarehouseSuccess: (state, action: PayloadAction<any>) => {
      state.deleteWarehouse.loading = false;
      state.deleteWarehouse.data = action.payload;
      state.deleteWarehouse.error = null;
    },
    deleteWarehouseError: (state, action: PayloadAction<string>) => {
      state.deleteWarehouse.loading = false;
      state.deleteWarehouse.data = null;
      state.deleteWarehouse.error = action.payload;
    },
    resetDeleteWarehouse: (state) => {
      state.deleteWarehouse = { loading: false, data: null, error: null };
    },
  },
});

export const {
  createWarehouseRequest,
  createWarehouseSuccess,
  createWarehouseError,
  resetCreateWarehouse,

  editWarehouseRequest,
  editWarehouseSuccess,
  editWarehouseError,
  resetEditWarehouse,

  getWarehouseListRequest,
  getWarehouseListSuccess,
  getWarehouseListError,
  resetWarehouseList,

  deleteWarehouseRequest,
  deleteWarehouseSuccess,
  deleteWarehouseError,
  resetDeleteWarehouse,
} = warehouseSlice.actions;

export default warehouseSlice.reducer;
